export const Environment = {
    softmexName: "Softmex Sp. z o. o.",
    production: false,
    appName: "Softmex System",
    apiEndpoint: "/api"
}
